// import BTC, { ReactComponent as BTCIcon } from "assets/svg/btcw.svg";
import BTC, { ReactComponent as BTCIcon } from "assets/svg/bitcoin.svg";
import CEUR, { ReactComponent as CEURIcon } from "assets/svg/ceur/ceurc.svg";
import ETH, { ReactComponent as ETHIcon } from "assets/svg/ethw.svg";
import CEDIS, {
  ReactComponent as CEDISIcon,
} from "assets/svg/icons-new/cediw.svg";
import CELO, {
  ReactComponent as CELOIcon,
} from "assets/svg/icons-new/celo.svg";
import CUSD, { ReactComponent as CUSDIcon } from "assets/svg/cusd.svg";
import NGN, {
  ReactComponent as NGNIcon,
} from "assets/svg/icons-new/nairaw.svg";
import KES, { ReactComponent as KESIcon } from "assets/svg/kes.svg";
import USDC, {
  ReactComponent as USDCIcon,
} from "assets/svg/icons-new/usdc.svg";
import USDT, {
  ReactComponent as USDTIcon,
} from "assets/svg/icons-new/usdt.svg";
import USDTT, {
  ReactComponent as USDTTIcon,
} from "assets/svg/icons-new/usdttron.svg";
import XLM, { ReactComponent as XLMIcon } from "assets/svg/icons-new/xlm.svg";
import XRP, { ReactComponent as XRPIcon } from "assets/svg/icons-new/xrp.svg";
import MATIC, { ReactComponent as MATICIcon } from "assets/svg/matic-c.svg";

import { useCallback } from "react";

// import toPrecision from "util/toPrecision";
// import formatter from "util/formatter";
// import constants from "config/constant";

const useCoinInfo = (coin = "ngn") => {
  const getWalletInfo = useCallback((coin) => {
    const map = {
      ngn: { label: "Nigerian Naira", icon: NGNIcon, image: NGN },
      ghs: { label: "Ghanian Cedis", icon: CEDISIcon, image: CEDIS },
      kes: { label: "Kenyan Shilings", icon: KESIcon, image: KES },
      btc: { label: "Bitcoin", icon: BTCIcon, image: BTC },
      tbtc: { label: "Bitcoin", icon: BTCIcon, image: BTC },
      eth: { label: "Ethereum", icon: ETHIcon, image: ETH },
      teth: { label: "Ethereum", icon: ETHIcon, image: ETH },
      usdc: { label: "USDC", icon: USDCIcon, image: USDC },
      usdt: { label: "USD Tether", icon: USDTIcon, image: USDT },
      celo: { label: "Celo", icon: CELOIcon, image: CELO },
      cusd: { label: "cUSD", icon: CUSDIcon, image: CUSD },
      ceur: { label: "cEUR", icon: CEURIcon, image: CEUR },
      xrp: { label: "Ripple", icon: XRPIcon, image: XRP },
      xlm: { label: "Stellar", icon: XLMIcon, image: XLM },
      matic: { label: "Polygon", icon: MATICIcon, image: MATIC },
      "usdt-tron": {
        label: "Tether USD (Tron)",
        icon: USDTTIcon,
        image: USDTT,
      },
    };

    return map[coin ?? "ngn"];
  }, []);

  return { ...getWalletInfo(coin), getWalletInfo };
};

export default useCoinInfo;
